import { useEffect } from "react";
import Hero from "@/components/sections/Hero";
import Manifesto from "@/components/sections/Manifesto";
import Services from "@/components/sections/Services";
import Process from "@/components/sections/Process";
import WhyData from "@/components/sections/WhyData";
import Marquee from "@/components/sections/Marquee";
import Industries from "@/components/sections/Industries";
import Network from "@/components/sections/Network";
import Testimonials from "@/components/sections/Testimonials";
import CTA from "@/components/sections/CTA";

export default function Home() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <main data-testid="page-home">
      <Hero />
      <Manifesto />
      <Services />
      <Process />
      <WhyData />
      <Marquee />
      <Industries />
      <Network />
      <Testimonials />
      <CTA />
    </main>
  );
}
